(function () {
  /* PF Drop: only one product dropdown open at a time.
     Theme slideUp/slideDown no-ops while an animation is queued but still
     flips aria-expanded — so .click()-to-close races and leaves panels
     stuck open/desynced. Force-close siblings by cloning the panel node
     (orphans in-flight animation timeouts onto a detached element). */

  function panelFor(label) {
    var group = label.parentNode;
    if (group) {
      var direct = group.querySelector(":scope > .accordion__text");
      if (direct) return direct;
    }
    var next = label.nextElementSibling;
    if (next && next.classList.contains("accordion__text")) return next;
    return null;
  }

  function forceClose(label) {
    if (!label) return;
    var content = panelFor(label);
    label.setAttribute("aria-expanded", "false");
    var group = label.parentNode;
    if (group) group.setAttribute("data-open", "false");
    if (!content || !content.parentNode) return;
    var fresh = content.cloneNode(true);
    fresh.removeAttribute("style");
    fresh.style.display = "none";
    fresh.setAttribute("aria-hidden", "true");
    content.parentNode.replaceChild(fresh, content);
  }

  function closeOthers(openLabel) {
    document.querySelectorAll(".product__meta .accordion__label").forEach(function (other) {
      if (other === openLabel) return;
      if (other.getAttribute("aria-expanded") === "true") forceClose(other);
      else {
        /* aria false but content still showing from a failed prior toggle */
        var content = panelFor(other);
        if (content && content.offsetHeight > 0) forceClose(other);
      }
    });
  }

  var obs = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.attributeName !== "aria-expanded") continue;
      var label = m.target;
      if (!label || !label.classList || !label.classList.contains("accordion__label")) continue;
      if (!label.closest(".product__meta")) continue;
      if (label.getAttribute("aria-expanded") !== "true") continue;
      closeOthers(label);
    }
  });

  function bind() {
    document.querySelectorAll(".product__meta .accordion__label").forEach(function (label) {
      obs.observe(label, { attributes: true, attributeFilter: ["aria-expanded"] });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
